export function copyableValue(valueToCopy) {
  return {
    isCopied: false,
    value: valueToCopy,
    tippyInstance: null,

    async handleCopy() {
      try {
        await navigator.clipboard.writeText(this.value);
        this.isCopied = true;
        this.tippyInstance?.setContent("Copied");
        setTimeout(() => {
          this.isCopied = false;
          this.tippyInstance?.setContent("Copy to clipboard");
        }, 1000);
      } catch (error) {
        console.error("Failed to copy to clipboard:", error);
      }
    },

    init() {
      if (this.$el && window.tippy) {
        this.tippyInstance = window.tippy(this.$el, {
          content: "Copy to clipboard",
          theme: "dx",
          arrow: false,
        });
      }
    },
  };
}
